export default {
  headerContent: {
    title: 'Mapfre Sigorta Özel Sağlık Sigortası Fiyat Sorgulama',
    slogan: "Özel Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ÖZEL SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Mapfre Sigorta Özel Sağlık Sigortası',
    description: {
      title: 'Mapfre Sigorta (3S) Özel Sağlık Sigortası Nedir? ',
      content: [
        'Mapfre Sigorta özel sağlık sigortası kaza veya hastalık sonucu alınması gereken tedavi masraflarını poliçe limitleri dahilinde karşılamaktadır.',
        '<ul><li>Birincisi, uzun vadede sağlıklı kalmanıza yardımcı olan kontroller gibi hastalanmadan bile kullanabileceğiniz birçok sağlık sigortası avantajı vardır.</li> <li>İkincisi, bir kaza geçirmeseniz, büyük sağlık masraflarınız olursa veya sağlık sigortası ödeneklerinizi kullanmanız gerekse bile, yine de hasta olsaydınız, olmayacağınızı bilmenin rahatlığını yaşarsınız. Tüm bu tıbbi masraflarla kendi başınıza yüzleşmek zorunda kalmazsınız. </li> <li> Son olarak, kendi sağlık sigortası poliçeniz olası sağlık durumlarında bütçenizi korur. Ve bir gün, hastalandığınızda ve tıbbi faturalarınızı ödemek için yardıma ihtiyacınız olduğunda, planınızdaki teminatlar size yardımcı olacaktır.</li></ul>',
        'Özel sağlık sigortasıyla kaliteli hizmeti düşük primlerle alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Mapfre Sigorta Özel Sağlık Sigortasını Neden Satın Almalıyım?',
      content: [
        {
          paragraph:
            'Hastalandığınızda veya yaralandığınızda sağlık harcamalarınızı kontrol edemezsiniz. Ancak sağlık sigortası priminiz için ne kadar ödediğinize gelince seçenekleriniz vardır. Bu, sağlık sigortanızı sürdürmek için sağlık sigortası şirketinize yaptığınız aylık ödemeleri ifade eder. ',
          subList: null
        },
        {
          paragraph:
            'Sağlık sigortası primleri kişiye ve planlara bağlı olarak farklılık gösterir. Bu sebeple en doğru teminatları seçerek en iyi fiyatı ödeyebilirsiniz. Mapfre Sigorta güvencesinde sağlık sigortası poliçenizi satın alarak sağlığınızı koruma altına alabilir ve olası ihtiyaçlarda özel hastanelerden kapsamlı hizmet alabilirsiniz.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Özel Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Özel Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Mapfre Sigorta Özel Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
